import * as MSAL from '@azure/msal-browser';

export interface UseHttpOptions {
  msalClient: MSAL.PublicClientApplication;
  scopes: string[];
}

export interface UseHttpResult {
  fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
}

export const useHttp = (options?: UseHttpOptions): [UseHttpResult, AbortController] => {
  const controller = new AbortController();
  const { signal } = controller;
  const res = {
    fetch: async (url: RequestInfo, init?: RequestInit) => {
      const headers: any = init ? { ...init.headers } : {};
      if (options) {
        let token = await getToken(options.msalClient, options.scopes);
        headers.Authorization = `Bearer ${token}`;
      }
      return await fetch(url, { ...init, headers, signal });
    },
  };
  return [res, controller];
};

export const getToken = async (msalObj: MSAL.PublicClientApplication, scopes: string[]) => {
  let allAccounts = msalObj.getAllAccounts();
  if (allAccounts.length > 0) {
    try {
      let token = await msalObj.acquireTokenSilent({
        account: allAccounts[0],
        scopes,
      });
      if (!token.accessToken) {
        throw new MSAL.InteractionRequiredAuthError();
      }
      return token.accessToken;
    } catch (error) {
      if (error instanceof MSAL.InteractionRequiredAuthError) {
        try {
          let token = await msalObj.acquireTokenPopup({ scopes });
          return token.accessToken;
        } catch (e) {
          console.log(e);
          throw e;
        }
      } else {
        console.log(error);
        throw error;
      }
    }
  } else {
    try {
      let token = await msalObj.acquireTokenPopup({ scopes });
      return token.accessToken;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
};
